import { render, staticRenderFns } from "./CouponCentre.vue?vue&type=template&id=d0ec6ede&"
import script from "./CouponCentre.vue?vue&type=script&lang=js&"
export * from "./CouponCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports